export default __webpack_public_path__ + "static/media/hya-diamond.238d56f4.png";